import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { filter, take } from 'rxjs/operators'
import { isSomething } from '@tokeet/tv3-platform'
import { SelectToCreateListingDialogComponent } from '@tv3/containers/channels/channel-connect/dialogs/select-to-create-listing-dialog/select-to-create-listing-dialog.component'

@Injectable({
  providedIn: SharedModule,
})
export class SelectToCreateListingDialogService {
  constructor(private dialog: MatDialog) {}

  public open(channelId) {
    const defaultConfig: MatDialogConfig = {
      width: '500px',
      height: 'auto',
      data: { channelId },
      panelClass: ['fixed-modal'],
    }

    return this.dialog
      .open(SelectToCreateListingDialogComponent, defaultConfig)
      .afterClosed()
      .pipe(
        take(1),
        filter((res) => isSomething(res))
      )
  }
}
